export const initialiseBirdie = (
  name: string,
  email: string,
  contactId: string
) => {
  // @ts-ignore
  window.birdieSettings = {
    contact_name: name,
    contact_email: email,
    contact_id: contactId
  }
}
